import * as d3 from 'd3';
import colors from './colors';

/********************
 ********************
 * EXTERNAL
 ********************
 ********************/
export function gaussianRandom() {
  let rand = 0;
  for (let i = 0; i < 6; i += 1) {
    rand += Math.random();
  }
  return rand / 6;
}

export function randomZeroToN(n) {
  return Math.floor(Math.random() * Math.floor(n));
}

const colorScale = d3.scaleOrdinal(d3.schemeCategory20);
export function colorByGroup(point) {
  return toVectorColor(varyLightness(colorScale(point.group)));
}

export function colorByDomain(point) {
  const color = point.domain === 'tor' ? colors.green : point.domain === 'i2p' ? colors.orange : colors.pink;
  return color.variedVector();
}

export function colorByFilter(point, filter) {
  const color = isPointActive(point, filter) ? colors.green : colors.grey;
  return color.variedVector();
}

export function sortPointsByFilter(points, filter) {
  return points
    .map((p, index) => ({
        active: isPointActive(p, filter),
        index
    }))
    .sort((a, b) => b.active - a.active);
}

export function isPointActive(point, filter) {
  return point.domain === filter || point.languages.includes(filter) || point.topics.includes(filter);
}


 function toVectorColor(color) {
   var rgb = d3.rgb(color);
   return [rgb.r / 255, rgb.g / 255, rgb.b / 255];
 }

 function varyLightness(color) {
   let hsl = d3.hsl(color);
   hsl.l *= 0.2 + Math.min(Math.random(), 0.5);
   return hsl;
 }



// WEBPACK FOOTER //
// ./src/helpers/helpers.js